<template>
  <div class="zs" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="invest-title" :fixed="true" title="我要参与" />
    <img
      @click="prev"
      class="invest-reback"
      src="../../assets/myInvest/reback.png"
    />
    <div class="addIn" v-if="btnShow">
      <van-row class="prepare">
        <van-col span="24" class="prepare_">
          <span class="border"></span>
          <span class="add-head">本店筹建公告</span>
        </van-col>
        <van-col span="24" class="moments">
          <div class="moments_">
            <p class="project">参与项目：{{ info.project_name }}</p>
            <p v-if="info.project_type == 1">
              总股数：<span>{{ info.target_shares }}</span
              >股
            </p>
            <!--<p v-if="info.project_type==2 && info.member_order_exist">总股数：<span>∞</span>股</p>-->
            <p v-if="info.order_count && info.member_order_exist">
              目前认购股数：{{ info.order_count.shares_sum }}股
            </p>
            <p class="per_money">每股单价：¥{{ info.share_price }}</p>
          </div>
        </van-col>
      </van-row>
      <van-row class="prepare hold">
        <van-col span="24" class="prepare_">
          <span class="border"></span>
          <span class="add-head">我要持股</span>
        </van-col>
        <van-col span="24" class="buy_max" v-if="canBuy != -1">
          可购买
          <!--<span class="fifty" v-if="canBuy == -1">∞</span>-->
          <span class="fifty">{{ canBuy }}</span
          >股
        </van-col>
        <van-col span="24" class="quantity">
          <van-cell-group @touchstart.stop="show = true">
            <van-field
              v-model="value"
              placeholder="请输入购买的持股数量"
              readonly
            />
          </van-cell-group>
          <van-number-keyboard
            :show="show"
            extra-key="."
            close-button-text="完成"
            @blur="onBlur"
            @input="onInput"
            @delete="onDelete"
          />
        </van-col>
        <van-col span="24" class="agree">
          <span
            class="circle"
            :class="{ circle1: isActive, circle2: hasError }"
            @click="changeCircle"
          ></span>
          <span>同意</span>

          <span class="bor-bottom" @click="aggre(14)"
            >《销巴生活众筹协议》</span
          >
          <!--<a class="bor-bottom" href="/aggrement?id=14&from=0">《销巴生活众筹协议》</a>-->
        </van-col>
      </van-row>
      <van-row class="notice">
        <van-col span="24" class="notice-">
          <p>特别说明：</p>
          <div v-html="info.special_announcement"></div>
          <!--<p v-if="info.maximum != 0">1、每人限参与{{info.member_max_shares}}股；</p>
          <p v-if="info.maximum == 0">1、每人限参与∞股；</p>
          <p>2、请在参与前认真阅读《销巴生活众筹协议》；</p>
          <p>3、如到期项目未筹建成功，认购资金无条件退回；</p>
          <p>4、众筹成功同时赠送等额积分，第二天开始转换红包，如超市筹建失败，红包作为红包作为利息转入个人红包账号，剩余积分清零，本金金额退回。</p>-->
        </van-col>
      </van-row>
    </div>
    <van-goods-action v-if="btnShow">
      <van-button size="large" @click="submit">立即参与</van-button>
    </van-goods-action>

    <div class="loading" v-if="!btnShow">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: "",
      show: false,
      isActive: true,
      hasError: false,
      info: {},
      canBuy: 0, //-1代表不限制众筹股数
      isiOSX: false,
      btnShow: false,
    };
  },
  created() {
    this.getInfo();
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    aggre(ID) {
      this.$router.push({
        path: "/cms-agreement/detail",
        query: {
          number: "stouzi_jipiao_xbgpxz",
          isApp: "1",
        },
      });
    },
    getInfo() {
      this.$api
        .get("/investment/member/project/detail", { id: this.$route.query.id })
        .then((res) => {
          this.getCanBuy();
          this.info = res;
        });
    },
    getCanBuy() {
      this.$api
        .get("/investment/member/order/create/available-shares", {
          project_id: this.$route.query.id,
        })
        .then((res) => {
          //project_type=1 按项目   project_type=2 按订单
          if (this.info.project_type == 1 && this.info.member_order_exist) {
            let diff =
              this.info.target_shares - this.info.order_count.shares_sum;
            if (diff >= 0 && diff < res.limit) {
              this.canBuy = diff;
            } else if (diff < 0) {
              this.canBuy = 0;
            } else {
              this.canBuy = res.limit;
            }
          } else if (this.info.project_type == 2) {
            this.canBuy = res.limit;
          } else {
            this.canBuy = res.limit;
          }
          this.btnShow = true;
        });
    },
    prev() {
      this.$router.go(-1);
    },
    submit() {
      if (this.canBuy != 0) {
        if (this.value && this.hasError) {
          this.$router.push({
            path: "/myInvest/confirm",
            query: {
              id: this.info.id,
              num: this.value,
            },
          });
        } else if (!this.hasError) {
          this.$toast("请同意《销巴生活众筹协议》");
        } else if (!this.value) {
          this.$toast("持股数量不能为空");
        }
      } else {
        this.$toast("您的可持股数量以达到极限，去看看别的项目吧！");
      }
    },
    onInput(value) {
      if (this.canBuy == 0) {
        this.value == 0;
      } else if (this.canBuy == -1) {
        if (value != ".") {
          this.value = "" + this.value + value;
        }
      } else {
        if (value != ".") {
          this.value = "" + this.value + value;
        }
      }
    },
    onBlur() {
      this.show = false;
      if (this.value && this.value < this.info.order_min_shares) {
        this.$toast("最低" + this.info.order_min_shares + "股起投");
        this.value = this.info.order_min_shares + "";
      } else if (
        this.value &&
        this.canBuy != -1 &&
        parseInt(this.value) > parseInt(this.canBuy)
      ) {
        this.$toast("最多可购买" + this.canBuy + "股");
        this.value = this.canBuy;
      }
    },
    onDelete() {
      //点击删除按钮触发，获取value字符串从第一位到倒数第二位
      //    this.value = this.value.substring(0, this.value.length - 1);
      this.value = "";
    },
    changeCircle() {
      this.isActive = !this.isActive;
      this.hasError = !this.hasError;
    },
  },
};
</script>
<style lang="less">
.zs {
  min-height: 100%;
  background-color: #f2f2f2;
  position: relative;
  .van-goods-action {
    .van-button {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #c49e80;
      border: none;
      img {
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 9px;
      }
    }
  }
  .invest {
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 27px;
      left: 0;
      z-index: 1;
    }
  }
  .addIn {
    padding-top: 68px;
    .prepare {
      background: #fff;
      padding-top: 16px;
      margin-bottom: 8px;
      .prepare_ {
        padding: 0 16px;
        position: relative;
        .border {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 16px;
          background-color: #c49e80;
        }
        .add-head {
          font-size: 18px;
          line-height: 25px;
          font-weight: 600;
          color: #333333;
          margin-left: 11px;
        }
      }
      .moments {
        padding: 0 16px;
        margin-top: 12px;
        margin-bottom: 16px;
        .moments_ {
          background-color: #f8f8f8;
          border-left: 3px solid #dddddd;
          padding-left: 12px;
          p {
            font-size: 15px;
            color: #777777;
            padding-bottom: 8px;
            line-height: 21px;
          }
          .project {
            padding-top: 12px;
          }
          .per_money {
            padding-bottom: 12px;
          }
        }
      }
    }
    .hold {
      margin-bottom: 0;
      .buy_max {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        padding: 12px 16px 0 16px;
        .fifty {
          color: #c49e80;
        }
      }
      .quantity {
        padding: 0 16px;
        height: 46px;
        line-height: 46px;
        .van-hairline--top-bottom::after {
          border: 0;
        }
        .van-hairline--top-bottom {
          height: 46px;
          line-height: 46px;
          border-bottom: 1px solid #eeeeee;
          .van-cell {
            padding: 11px 0;
            font-size: 22px;
            color: #c0c0c0;
          }
          @media screen and (max-width: 320px) {
            .van-cell {
              font-size: 19px;
            }
          }
        }
      }
      .agree {
        padding: 0 16px;
        margin-top: 17px;
        line-height: 18px;
        margin-bottom: 16px;
        span {
          font-size: 13px;
          color: #999999;
          display: block;
          float: left;
        }
        .circle {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
        @media screen and (max-width: 320px) {
          .circle {
            width: 14px;
            height: 14px;
            margin-top: 2px;
          }
        }
        .circle1 {
          background: url("../../assets/myInvest/circle1.png") no-repeat center
            center;
          background-size: 100% 100%;
        }
        .circle2 {
          background: url("../../assets/myInvest/circle2.png") no-repeat center
            center;
          background-size: 100% 100%;
        }
        .bor-bottom {
          border-bottom: 1px solid #999999;
          line-height: 17px;
          font-size: 13px;
          color: #999;
          display: block;
          float: left;
          text-decoration: none;
        }
        /*.bor-bottom:visited {
        	color: #999;
        }
        .bor-bottom:link {
        	color: #999;
        }
        .bor-bottom:active {
        	color: #999;
        }*/
      }
    }
    .notice {
      padding-top: 12px;
      padding-bottom: 76px;
      .notice- {
        padding: 0 16px;
        p {
          font-size: 12px;
          color: #999999;
          font-weight: 500;
          line-height: 20px;
        }
      }
    }
  }
  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;
    img {
      width: 35%;
      margin-top: 50%;
    }
  }
}
.isiOSX {
  .invest {
    &-title {
      padding-top: 44px;
    }
    &-reback {
      top: 45px;
    }
  }
  .addIn {
    padding-top: 88px;
  }
}
</style>





